import React, { useEffect, useRef } from "react";
import { useLottie } from "lottie-react";
import linesData from "../../assets/yellow-lines.json";
import fieldData from "../../assets/soccer-field.json";
// import ballData from "../../assets/soccer-ball.json"; // ← ADD THIS
import "./BackgroundLottie.css";

/** Subtle background accents: yellow lines (BR) + soccer field (TR, 45°) + soccer ball (center, static). */
export default function BackgroundLottie() {
  // --- Yellow lines (loop) ---
  const linesRef = useRef(null);
  const { View: LinesView, setSpeed: setLinesSpeed } = useLottie(
    { animationData: linesData, loop: true, autoplay: true, lottieRef: linesRef },
    {}
  );

  // --- Soccer field (ping-pong) ---
  const fieldRef = useRef(null);
  const dirRef = useRef(1);
  const { View: FieldView, setSpeed: setFieldSpeed } = useLottie(
    { animationData: fieldData, loop: false, autoplay: true, lottieRef: fieldRef },
    {}
  );

  // --- Soccer ball (static) ---
  const ballRef = useRef(null);
  const { View: BallView } = useLottie(
    { loop: false, autoplay: false, lottieRef: ballRef },
    {}
  );

  useEffect(() => {
    // keep your existing speeds
    setLinesSpeed(0.10);
    setFieldSpeed(0.15);

    // soccer field ping-pong
    const anim = fieldRef.current;
    if (anim) {
      const onComplete = () => {
        dirRef.current *= -1;
        anim.setDirection(dirRef.current);
        anim.play();
      };
      anim.addEventListener("complete", onComplete);
      return () => anim.removeEventListener("complete", onComplete);
    }
  }, [setLinesSpeed, setFieldSpeed]);

  useEffect(() => {
    // freeze the ball at frame 0 (static)
    const ball = ballRef.current;
    if (ball) {
      ball.goToAndStop(0, true);
    }
  }, []);

  return (
    <div className="lottie-bg" aria-hidden>
      {/* keep your existing spots as-is */}
      <div className="lottie-lines-spot">{LinesView}</div>
      <div className="lottie-field-spot" style={{ width: "100%", height: "100%" }}>
        {FieldView}
      </div>

      {/* NEW: centered static ball */}
      <div className="lottie-ball-spot">{BallView}</div>
    </div>
  );
}
